export const KPI_COLLECTIONS = ({ processedDashboardData, targetCollections, isCollectionsAllowed, handleChangeTab, theme }) => {
    return (
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 6px 12px rgba(0,0,0,0.08)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden',
            cursor: isCollectionsAllowed ? 'pointer' : 'default'
        }}
        onClick={isCollectionsAllowed ? () => handleChangeTab('collections') : null}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= (targetCollections / 5) ? '#28a745' : 
                            (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= ((targetCollections / 5) * 5/7) ? '#ffc107' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 6px 0', letterSpacing: '0.5px' }}>
                        COLLECTIONS
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= (targetCollections / 5) ? '#28a745' : 
                                    (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= ((targetCollections / 5) * 5/7) ? '#ffc107' : '#6c757d',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData?.collectionsKpis?.todayTotal || 0}
                        </span>
                        <span style={{
                            fontSize: '14px',
                            color: (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= (targetCollections / 5) ? '#28a745' : 
                                    (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= ((targetCollections / 5) * 5/7) ? '#ffc107' : '#6c757d',
                            fontWeight: '600',
                            textTransform: 'uppercase'
                        }}>
                            TODAY
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= (targetCollections / 5) ? 'rgba(40, 167, 69, 0.1)' : 
                                (processedDashboardData?.collectionsKpis?.todayTotal || 0) >= ((targetCollections / 5) * 5/7) ? 'rgba(255, 193, 7, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '8px',
                    borderRadius: '8px',
                    fontSize: '18px'
                }}>
                    📦
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Today's total:</span><span>{processedDashboardData?.collectionsKpis?.todayTotal || 0} pallets</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Week total:</span><span>{processedDashboardData?.collectionsKpis?.weekTotal || 0} pallets</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Daily avg (5-day):</span><span>{processedDashboardData?.collectionsKpis?.dailyAverage || 0} pallets</span>
                </div>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.collectionsKpis?.weekTotal || 0) >= targetCollections ? '#28a745' : 
                        (processedDashboardData?.collectionsKpis?.weekTotal || 0) >= (targetCollections * 250/350) ? '#ffc107' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: {targetCollections}+ Weekly ({targetCollections / 5}/day) • {(processedDashboardData?.collectionsKpis?.weekTotal || 0) >= targetCollections ? 'EXCELLENT' : (processedDashboardData?.collectionsKpis?.weekTotal || 0) >= (targetCollections * 250/350) ? 'GOOD' : 'NEEDS IMPROVEMENT'}
            </div>
        </div>
    )
}